module.exports = __webpack_public_path__ + "img/7722170.c194ae39.png";